import PropTypes from 'prop-types';

const Logo = ({ className = '', onClick, ...otherProps }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={`icon ${className}`} viewBox="0 0 700 700" preserveAspectRatio="xMidYMid meet" onClick={onClick} {...otherProps}>
      <g transform="translate(0,700) scale(0.1,-0.1)" fill="#ff5a1f" stroke="none">
        <path d="M3280 6993 c-19 -1 -87 -8 -150 -14 -911 -86 -1788 -566 -2369 -1297 -707 -888 -940 -2076 -620 -3168 83 -287 236 -627 389 -872 157 -251 395 -535 609 -729 558 -504 1225 -804 1986 -893 155 -18 460 -24 620 -11 496 39 904 152 1330 366 216 109 340 185 528 326 714 536 1199 1330 1346 2204 37 219 46 336 46 595 0 258 -9 377 -46 593 -93 551 -318 1072 -658 1522 -666 880 -1709 1393 -2811 1383 -91 -1 -181 -3 -200 -5z m1560 -2322 c344 -78 574 -263 697 -561 27 -66 49 -151 67 -258 l6 -32 -286 2 -286 3 -17 65 c-49 197 -208 310 -436 310 -237 0 -398 -112 -488 -340 -44 -113 -52 -171 -51 -370 1 -156 4 -197 22 -265 77 -284 248 -425 517 -425 146 0 254 40 337 124 48 49 96 137 105 192 l6 34 287 0 287 0 -9 -57 c-22 -141 -95 -299 -198 -426 -215 -268 -581 -403 -968 -358 -389 45 -677 243 -841 578 -169 345 -170 874 -2 1218 166 340 466 546 856 589 84 9 311 -4 395 -23z m-1520 -231 l0 -230 -355 0 -355 0 0 -940 0 -940 -275 0 -275 0 0 940 0 940 -355 0 -355 0 0 230 0 230 985 0 985 0 0 -230z"/>
      </g>
  </svg>
  );
}

Logo.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};

export default Logo;